import { queryOptions } from '@tanstack/react-query';

import { QUERY_STALE_TIME } from '@/config/queryDefaults';

import { fetchMarketEvents } from './marketEvents.api';

export const marketEventsOptions = {
  all: () => ['morning-intel', 'market-events'] as const,

  list: () =>
    queryOptions({
      queryKey: marketEventsOptions.all(),
      queryFn: fetchMarketEvents,
      // The batch runs nightly; refetching on every window focus buys nothing.
      staleTime: QUERY_STALE_TIME.standard
    })
};
